import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { Helpers } from "../../../helpers/Helpers";
import { AddConstantResponse } from "../../../models/response/constant/AddConstantResponse";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import { ConstantService } from "../../../services/ConstantService";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import toast from "react-hot-toast";
import { GetConstantListResponse } from "../../../models/response/constant/GetConstantListResponse";
import { GetCompanyListResponse, GetCompanyListResponseItem } from "../../../models/response/company/GetCompanyListResponse";
import { GetCompanyByIdResponseCompanyAddress } from "../../../models/response/company/GetCompanyByIdResponse";
import { useNavigate, useSearchParams } from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import { CompanyService } from "../../../services/CompanyService";
import { AddLandOrderRequest } from "../../../models/request/landOrder/AddLandOrderRequest";
import { LandOrderService } from "../../../services/LandOrderService";
import { GetLandOrderByIdResponse, GetLandOrderByIdResponseExpectedIncomeOutcome, GetLandOrderByIdResponseFileArchive, GetLandOrderByIdResponseOrderDetail } from "../../../models/response/landOrder/GetLandOrderByIdResponse";
import GeneralInformation from "./Components/GeneralInformation";
import { GetCompanyByIdResponse } from "../../../models/response/company/GetCompanyByIdResponse";
import FirmInformation from "./Components/FirmInformation";
import { AddLandOrderResponse } from "../../../models/response/landOrder/AddLandOrderResponse";
import LocationInformation, { LocationInformationModel } from "./Components/LocationInformation";
import moment from "moment";
import DateInformation from "./Components/DateInformation";
import VoyageInformation from "./Components/VoyageInformation";
import OrderDetails from "./Components/OrderDetails";
import ExpectedIncomeOutcome from "./Components/ExpectedIncomeOutcome";
import FileArchives from "./Components/FileArchives";

const LandOrderAdd = () => {
    const navigate = useNavigate();
    const pageName = "Uluslararası Kara > Siparişler"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const generalInformationRef: any = useRef();
    const firmInformationRef: any = useRef();
    const locationInformationRef: any = useRef();
    const dateInformationRef: any = useRef();
    const voyageInformationRef: any = useRef();
    const detailsRef: any = useRef();
    const expectedIncomeRef: any = useRef();
    const expectedOutcomeRef: any = useRef();
    const fileArchivesRef: any = useRef();

    const [landOrderId, setLandOrderId] = useState<string | undefined>(undefined);

    // GENEL BİLGİLER
    const [refNo, setRefNo] = useState<string | undefined>(undefined);
    const [selectedCustomer, setSelectedCustomer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedOperationType, setSelectedOperationType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedOrderStatus, setSelectedOrderStatus] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedIncoterm, setSelectedIncoterm] = useState<CustomSingleSelectModel | undefined>(undefined);

    // FİRMA BİLGİLERİ
    const [selectedSenderCompany, setSelectedSenderCompany] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [senderAddressList, setSenderAddressList] = useState<GetCompanyByIdResponseCompanyAddress[]>([]);
    const [selectedSenderAddressType, setSelectedSenderAddressType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [senderAddressText, setSenderAddressText] = useState<string | undefined>(undefined);

    const [selectedReceiverCompany, setSelectedReceiverCompany] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [receiverAddressList, setReceiverAddressList] = useState<GetCompanyByIdResponseCompanyAddress[]>([]);
    const [selectedReceiverAddressType, setSelectedReceiverAddressType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [receiverAddressText, setReceiverAddressText] = useState<string | undefined>(undefined);

    const [selectedLoadingCompany, setSelectedLoadingCompany] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [loadingAddressList, setLoadingAddressList] = useState<GetCompanyByIdResponseCompanyAddress[]>([]);
    const [selectedLoadingAddressType, setSelectedLoadingAddressType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [loadingAddressText, setLoadingAddressText] = useState<string | undefined>(undefined);

    const [selectedUnloadingCompany, setSelectedUnloadingCompany] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [unloadingAddressList, setUnloadingAddressList] = useState<GetCompanyByIdResponseCompanyAddress[]>([]);
    const [selectedUnloadingAddressType, setSelectedUnloadingAddressType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [unloadingAddressText, setUnloadingAddressText] = useState<string | undefined>(undefined);

    const [selectedDutyCompany, setSelectedDutyCompany] = useState<CustomSingleSelectModel | undefined>(undefined);

    // LOKASYON BİLGİLERİ
    const [selectedLoadingInformation, setSelectedLoadingInformation] = useState<LocationInformationModel>({
        selectedCountry: undefined,
        selectedCounty: undefined,
        selectedDistrict: undefined
    })
    const [selectedUnloadingInformation, setSelectedUnloadingInformation] = useState<LocationInformationModel>({
        selectedCountry: undefined,
        selectedCounty: undefined,
        selectedDistrict: undefined
    })
    // const [selectedCountry, setSelectedCountry] = useState<CustomSingleSelectModel | undefined>(undefined);
    // const [loadingCountry, setLoadingCountry] = useState<string | undefined>('');
    // const [loadingCounty, setLoadingCounty] = useState<string | undefined>('');
    // const [loadingDistrict, setLoadingDistrict] = useState<string | undefined>('');
    // const [unloadingCountry, setUnloadingCountry] = useState<string | undefined>('');
    // const [unloadingCounty, setUnloadingCounty] = useState<string | undefined>('');
    // const [unloadingDistrict, setUnloadingDistrict] = useState<string | undefined>('');

    // TARİH BİLGİLERİ
    const [orderDate, setOrderDate] = useState<string | undefined>(new Date().toISOString().split('T')[0].split(' ')[0]);
    const [loadingDate, setLoadingDate] = useState<string | undefined>(undefined);
    const [deliverDate, setDeliverDate] = useState<string | undefined>(undefined);
    const [estDeliverDate, setEstDeliverDate] = useState<string | undefined>(undefined);

    // SEFER BİLGİLERİ
    const [selectedVoyageStatus, setSelectedVoyageStatus] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [voyageNo, setVoyageNo] = useState<string | undefined>(undefined);
    const [selectedVehicle, setSelectedVehicle] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedTrailer, setSelectedTrailer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDriver, setSelectedDriver] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedSupplier, setSelectedSupplier] = useState<CustomSingleSelectModel | undefined>(undefined);

    // DETAY BİLGİLERİ
    const [orderDetails, setOrderDetails] = useState<GetLandOrderByIdResponseOrderDetail[]>([]);

    // BEKLENEN GELİR
    const [expectedIncomes, setExpectedIncomes] = useState<GetLandOrderByIdResponseExpectedIncomeOutcome[]>([]);
    const [expectedOutcomes, setExpectedOutcomes] = useState<GetLandOrderByIdResponseExpectedIncomeOutcome[]>([]);

    // DOSYA ARŞİV
    const [fileArchives, setFileArchives] = useState<GetLandOrderByIdResponseFileArchive[]>([]);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, []);

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var response2: GetConstantListResponse = await ConstantService.getConstantList('ORDER_STATUS', undefined, "1");

            if (!response2.isSuccess) {
                toast.error(response2.message)
                return;
            }

            if (response2.data.length > 0) {
                setSelectedOrderStatus({ label: response2.data[0].value, value: response2.data[0].constantId });
            }

            var response2: GetConstantListResponse = await ConstantService.getConstantList('OPERATION_TYPE', undefined, "2");

            if (!response2.isSuccess) {
                toast.error(response2.message)
                return;
            }

            if (response2.data.length > 0) {
                setSelectedOperationType({ label: response2.data[0].value, value: response2.data[0].constantId });
            }

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetLandOrderByIdResponse = await LandOrderService.getLandOrderById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setLandOrderId(response.data.landOrderId);

                setRefNo(response.data.refNo);

                if (response.data.operationTypeId)
                    setSelectedOperationType({ label: response.data.operationTypeName, value: response.data.operationTypeId });

                if (response.data.orderStatusId)
                    setSelectedOrderStatus({ label: response.data.orderStatusName, value: response.data.orderStatusId });

                if (response.data.customerId)
                    setSelectedCustomer({ label: response.data.customerName, value: response.data.customerId });

                if (response.data.incotermId)
                    setSelectedIncoterm({ label: response.data.incotermName, value: response.data.incotermId });

                if (response.data.senderFirmId) {
                    setSelectedSenderCompany({ label: response.data.senderFirmName, value: response.data.senderFirmId })
                    setSelectedSenderAddressType({ label: response.data.senderFirmAddressTypeName, value: response.data.senderFirmAddressTypeId });
                    setSenderAddressText(response.data.senderFirmAddressText);
                    getCompanyById(response.data.senderFirmId, setSenderAddressList, setSelectedSenderAddressType, setSenderAddressText, false, setSelectedLoadingInformation);
                }

                if (response.data.receiverFirmId) {
                    setSelectedReceiverCompany({ label: response.data.receiverFirmName, value: response.data.receiverFirmId })
                    setSelectedReceiverAddressType({ label: response.data.receiverFirmAddressTypeName, value: response.data.receiverFirmAddressTypeId });
                    setReceiverAddressText(response.data.receiverFirmAddressText);
                    getCompanyById(response.data.receiverFirmId, setReceiverAddressList, setSelectedReceiverAddressType, setReceiverAddressText, false, setSelectedUnloadingInformation);
                }

                if (response.data.loadingFirmId) {
                    setSelectedLoadingCompany({ label: response.data.loadingFirmName, value: response.data.loadingFirmId })
                    setSelectedLoadingAddressType({ label: response.data.loadingFirmAddressTypeName, value: response.data.loadingFirmAddressTypeId });
                    setLoadingAddressText(response.data.loadingFirmAddressText);
                    getCompanyById(response.data.loadingFirmId, setLoadingAddressList, setSelectedLoadingAddressType, setLoadingAddressText, false, setSelectedLoadingInformation);
                }

                if (response.data.unloadingFirmId) {
                    setSelectedUnloadingCompany({ label: response.data.unloadingFirmName, value: response.data.unloadingFirmId })
                    setSelectedUnloadingAddressType({ label: response.data.unloadingFirmAddressTypeName, value: response.data.unloadingFirmAddressTypeId });
                    setUnloadingAddressText(response.data.unloadingFirmAddressText);
                    getCompanyById(response.data.unloadingFirmId, setUnloadingAddressList, setSelectedUnloadingAddressType, setUnloadingAddressText, false, setSelectedUnloadingInformation);
                }

                if (response.data.dutyFirmId) {
                    setSelectedDutyCompany({ label: response.data.dutyFirmName, value: response.data.dutyFirmId });
                }

                setOrderDate(response.data.orderDate);
                setLoadingDate(response.data.loadingDate);
                setDeliverDate(response.data.deliverDate);
                setEstDeliverDate(response.data.estDeliverDate);

                if (response.data.voyageStatusId)
                    setSelectedVoyageStatus({ label: response.data.voyageStatusName, value: response.data.voyageStatusId });

                if (response.data.vehicleId)
                    setSelectedVehicle({ label: response.data.vehicleName, value: response.data.vehicleId });

                if (response.data.driverId)
                    setSelectedDriver({ label: response.data.driverName, value: response.data.driverId });

                setVoyageNo(response.data.voyageNo);

                if (response.data.trailerId)
                    setSelectedTrailer({ label: response.data.trailerName, value: response.data.trailerId });

                if (response.data.supplierId)
                    setSelectedSupplier({ label: response.data.supplierName, value: response.data.supplierId });

                setOrderDetails(response.data.orderDetails);
                setExpectedIncomes(response.data.expectedIncomeOutcomes.filter(x => x.isIncome));
                setExpectedOutcomes(response.data.expectedIncomeOutcomes.filter(x => !x.isIncome));
                setFileArchives(response.data.fileArchives);

                setSelectedUnloadingInformation({
                    selectedCountry: response.data.unloadingFirmAddressCountryId ? { label: response.data.unloadingFirmAddressCountryName + '', value: response.data.unloadingFirmAddressCountryId } : undefined,
                    selectedCounty: response.data.unloadingFirmAddressCountyId ? { label: response.data.unloadingFirmAddressCountyName + '', value: response.data.unloadingFirmAddressCountyId } : undefined,
                    selectedDistrict: response.data.unloadingFirmAddressDistrictId ? { label: response.data.unloadingFirmAddressDistrictName + '', value: response.data.unloadingFirmAddressDistrictId } : undefined
                })

                setSelectedLoadingInformation({
                    selectedCountry: response.data.loadingFirmAddressCountryId ? { label: response.data.loadingFirmAddressCountryName + '', value: response.data.loadingFirmAddressCountryId } : undefined,
                    selectedCounty: response.data.loadingFirmAddressCountyId ? { label: response.data.loadingFirmAddressCountyName + '', value: response.data.loadingFirmAddressCountyId } : undefined,
                    selectedDistrict: response.data.loadingFirmAddressDistrictId ? { label: response.data.loadingFirmAddressDistrictName + '', value: response.data.loadingFirmAddressDistrictId } : undefined
                })
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const getDistricts = async (_countyId: string, isFirstTime: boolean = false) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response2: GetConstantListResponse = await ConstantService.getConstantList('DISTRICT', _countyId)

            if (!response2.isSuccess) {
                toast.error(response2.message)
                return [];
            }

            var arr: CustomSingleSelectModel[] = response2.data.map(function (x) {
                return { label: x.value, value: x.constantId }
            })

            return arr;
        } catch (error: any) {
            toast.error(error)
            return [];
        }
        finally {
            if (!isFirstTime)
                dispatch(storeActivityIndicator(false))
        }
    }

    const saveLandOrder = async () => {
        try {
            if (!selectedOperationType)
                toast.error('Operasyon Türü alanını doldurunuz!')
            else if (!selectedOrderStatus)
                toast.error('Sipariş Durumu alanını doldurunuz!')
            else if (!selectedCustomer)
                toast.error('Müşteri alanını doldurunuz!')
            else if (!selectedSenderCompany || !selectedSenderAddressType || Helpers.isEmpty(senderAddressText))
                toast.error('Gönderici Firma alanını doldurunuz!')
            else if (!selectedReceiverCompany || !selectedReceiverAddressType || Helpers.isEmpty(receiverAddressText))
                toast.error('Alıcı Firma alanını doldurunuz!')
            else if (!selectedLoadingCompany || !selectedLoadingAddressType || Helpers.isEmpty(loadingAddressText))
                toast.error('Yükleme Firması alanını doldurunuz!')
            else if (!selectedUnloadingCompany || !selectedUnloadingAddressType || Helpers.isEmpty(unloadingAddressText))
                toast.error('Boşaltma Firması alanını doldurunuz!')
            else if (!selectedDutyCompany)
                toast.error('Gümrük Firması alanını doldurunuz!')
            else if (Helpers.isEmpty(orderDate))
                toast.error('Sipariş Tarihi alanını doldurunuz!')
            else if (!Helpers.isEmpty(loadingDate) && !(moment(loadingDate) >= moment(orderDate)))
                toast.error('Yükleme Tarihi, Sipariş Tarihi alanından büyük veya eşit olmalıdır!')
            else if (!Helpers.isEmpty(estDeliverDate) && !(moment(estDeliverDate) >= moment(loadingDate)))
                toast.error('Tahmini Teslim Tarihi, Yükleme Tarihi alanından büyük veya eşit olmalıdır!')
            else if (!Helpers.isEmpty(deliverDate) && !(moment(deliverDate) >= moment(loadingDate) || moment(deliverDate) >= moment(estDeliverDate)))
                toast.error('Teslim Tarihi, Yükleme Tarihi veya Tahmini Teslim Tarihi alanından büyük veya eşit olmalıdır!')
            else {
                dispatch(storeActivityIndicator(true));

                var obj: AddLandOrderRequest = {
                    landOrderId: landOrderId,
                    customerId: selectedCustomer?.value,
                    incotermId: selectedIncoterm?.value,
                    operationTypeId: selectedOperationType?.value,
                    orderStatusId: selectedOrderStatus?.value,
                    refNo: refNo,
                    dutyFirmId: selectedDutyCompany.value,
                    loadingFirmAddressId: loadingAddressList.find(x => x.addressTypeId == selectedLoadingAddressType.value)?.companyAddressId,
                    receiverFirmAddressId: receiverAddressList.find(x => x.addressTypeId == selectedReceiverAddressType.value)?.companyAddressId,
                    senderFirmAddressId: senderAddressList.find(x => x.addressTypeId == selectedSenderAddressType.value)?.companyAddressId,
                    unloadingFirmAddressId: unloadingAddressList.find(x => x.addressTypeId == selectedUnloadingAddressType.value)?.companyAddressId,
                    loadingFirmAddressText: loadingAddressText,
                    receiverFirmAddressText: receiverAddressText,
                    senderFirmAddressText: senderAddressText,
                    unloadingFirmAddressText: unloadingAddressText,
                    deliverDate: deliverDate,
                    estDeliverDate: estDeliverDate,
                    loadingDate: loadingDate,
                    orderDate: orderDate,
                    driverId: selectedDriver?.value,
                    supplierId: selectedSupplier?.value,
                    trailerId: selectedTrailer?.value,
                    vehicleId: selectedVehicle?.value,
                    voyageNo: voyageNo,
                    voyageStatusId: selectedVoyageStatus?.value,
                    orderDetails: orderDetails.map(function (x) {
                        return {
                            currencyTypeId: x.currencyTypeId,
                            desi: x.desi,
                            gTipId: x.gTipId,
                            height: x.height,
                            length: x.length,
                            potTypeId: x.potTypeId,
                            priceWeight: x.priceWeight,
                            product: x.product,
                            quantity: x.quantity,
                            volume: x.volume,
                            weight: x.weight,
                            width: x.width
                        }
                    }),
                    expectedIncomeOutcomes: [...expectedIncomes, ...expectedOutcomes].map(function (x) {
                        return {
                            currency: x.currency,
                            currencyTypeId: x.currencyTypeId,
                            description: x.description,
                            invoiceDate: x.invoiceDate,
                            invoiceNo: x.invoiceNo,
                            isApproved: x.isApproved ? 1 : 0,
                            isIncome: x.isIncome ? 1 : 0,
                            quantity: x.quantity,
                            serviceId: x.serviceId,
                            taxPrice: x.taxPrice,
                            totalPrice: x.totalPrice,
                            totalWithoutTaxPrice: x.totalWithoutTaxPrice,
                            unitPrice: x.unitPrice,
                            taxRate: x.taxRate
                        }
                    }),
                    fileArchives: fileArchives.map(function (x) {
                        return {
                            description: x.description,
                            entityId: x.entityId,
                            file: x.fileArchiveFile,
                            fileName: x.fileName,
                            fileTypeId: x.fileTypeId,
                            fileArchiveId: x.fileArchiveId
                        }
                    }),
                    unloadingFirmAddressCountryId: selectedUnloadingInformation.selectedCountry?.value,
                    unloadingFirmAddressCountyId: selectedUnloadingInformation.selectedCounty?.value,
                    unloadingFirmAddressDistrictId: selectedUnloadingInformation.selectedDistrict?.value,
                    loadingFirmAddressCountryId: selectedLoadingInformation.selectedCountry?.value,
                    loadingFirmAddressCountyId: selectedLoadingInformation.selectedCounty?.value,
                    loadingFirmAddressDistrictId: selectedLoadingInformation.selectedDistrict?.value
                }

                var response: AddLandOrderResponse = await LandOrderService.addLandOrder(obj);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const getCompanyById = async (
        _companyId: string,
        setVariableAddressList: React.Dispatch<React.SetStateAction<GetCompanyByIdResponseCompanyAddress[]>>,
        setSelectedVariableAddressType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>,
        setVariableAddressText: React.Dispatch<React.SetStateAction<string | undefined>>,
        _setDefault: boolean = true,
        setInformation: React.Dispatch<React.SetStateAction<LocationInformationModel>> | undefined = undefined
    ) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(_companyId);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setVariableAddressList(response.data.companyAddresses);

            if (_setDefault) {
                if (response.data.companyAddresses.length > 0) {
                    var a = response.data.companyAddresses.find(x => x.isDefault);

                    if (a) {
                        setSelectedVariableAddressType({ label: response.data.companyAddresses.find(x => x.isDefault)?.addressTypeName + '', value: a?.addressTypeId + '' })
                        setVariableAddressText(a?.addressText);
                    }
                    else {
                        a = response.data.companyAddresses[0];
                        setSelectedVariableAddressType({ label: a.addressTypeName + '', value: a.addressTypeId + '' });
                        setVariableAddressText(a.addressText);
                    }

                    if (a && setInformation) {
                        setInformation({
                            selectedCountry: a.countryId ? { label: a.countryName + '', value: a.countryId } : undefined,
                            selectedCounty: a.countyId ? { label: a.countyName + '', value: a.countyId } : undefined,
                            selectedDistrict: a.districtId ? { label: a.districtName + '', value: a.districtId } : undefined
                        })
                    }
                }
                else {
                    setSelectedVariableAddressType(undefined);
                    setVariableAddressText('');

                    if (setInformation) {
                        setInformation({
                            selectedCountry: undefined,
                            selectedCounty: undefined,
                            selectedDistrict: undefined
                        })
                    }
                }
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <PageHeader
                        items={[
                            { text: 'Genel Bilgiler', ref: generalInformationRef },
                            { text: 'Sefer Bilgileri', ref: voyageInformationRef },
                            { text: 'Firma Bilgileri', ref: firmInformationRef },
                            { text: 'Lokasyon Bilgileri', ref: locationInformationRef },
                            { text: 'Tarih Bilgileri', ref: dateInformationRef },
                            { text: 'Sipariş Detay Bilgileri', ref: detailsRef },
                            { text: 'Beklenen Gelir', ref: expectedIncomeRef },
                            { text: 'Beklenen Gider', ref: expectedOutcomeRef },
                            { text: 'Dijital Arşiv', ref: fileArchivesRef },
                        ]}
                    />

                    <GeneralInformation
                        generalInformationRef={generalInformationRef}
                        refNo={refNo}
                        selectedCustomer={selectedCustomer}
                        selectedIncoterm={selectedIncoterm}
                        selectedOperationType={selectedOperationType}
                        selectedOrderStatus={selectedOrderStatus}
                        setRefNo={setRefNo}
                        setSelectedCustomer={setSelectedCustomer}
                        setSelectedIncoterm={setSelectedIncoterm}
                        setSelectedOperationType={setSelectedOperationType}
                        setSelectedOrderStatus={setSelectedOrderStatus}
                    />

                    <VoyageInformation
                        selectedDriver={selectedDriver}
                        selectedSupplier={selectedSupplier}
                        selectedTrailer={selectedTrailer}
                        selectedVehicle={selectedVehicle}
                        selectedVoyageStatus={selectedVoyageStatus}
                        setSelectedDriver={setSelectedDriver}
                        setSelectedSupplier={setSelectedSupplier}
                        setSelectedTrailer={setSelectedTrailer}
                        setSelectedVehicle={setSelectedVehicle}
                        setSelectedVoyageStatus={setSelectedVoyageStatus}
                        setVoyageNo={setVoyageNo}
                        voyageInformationRef={voyageInformationRef}
                        voyageNo={voyageNo}
                    />

                    <FirmInformation
                        firmInformationRef={firmInformationRef}
                        getCompanyById={getCompanyById}
                        selectedSenderAddressType={selectedSenderAddressType}
                        selectedSenderCompany={selectedSenderCompany}
                        senderAddressList={senderAddressList}
                        senderAddressText={senderAddressText}
                        setSelectedSenderAddressType={setSelectedSenderAddressType}
                        setSelectedSenderCompany={setSelectedSenderCompany}
                        setSenderAddressList={setSenderAddressList}
                        setSenderAddressText={setSenderAddressText}
                        selectedReceiverAddressType={selectedReceiverAddressType}
                        selectedReceiverCompany={selectedReceiverCompany}
                        receiverAddressList={receiverAddressList}
                        receiverAddressText={receiverAddressText}
                        setSelectedReceiverAddressType={setSelectedReceiverAddressType}
                        setSelectedReceiverCompany={setSelectedReceiverCompany}
                        setReceiverAddressList={setReceiverAddressList}
                        setReceiverAddressText={setReceiverAddressText}
                        selectedLoadingAddressType={selectedLoadingAddressType}
                        selectedLoadingCompany={selectedLoadingCompany}
                        loadingAddressList={loadingAddressList}
                        loadingAddressText={loadingAddressText}
                        setSelectedLoadingAddressType={setSelectedLoadingAddressType}
                        setSelectedLoadingCompany={setSelectedLoadingCompany}
                        setLoadingAddressList={setLoadingAddressList}
                        setLoadingAddressText={setLoadingAddressText}
                        selectedUnloadingAddressType={selectedUnloadingAddressType}
                        selectedUnloadingCompany={selectedUnloadingCompany}
                        unloadingAddressList={unloadingAddressList}
                        unloadingAddressText={unloadingAddressText}
                        setSelectedUnloadingAddressType={setSelectedUnloadingAddressType}
                        setSelectedUnloadingCompany={setSelectedUnloadingCompany}
                        setUnloadingAddressList={setUnloadingAddressList}
                        setUnloadingAddressText={setUnloadingAddressText}
                        selectedDutyCompany={selectedDutyCompany}
                        setSelectedDutyCompany={setSelectedDutyCompany}
                        setSelectedLoadingInformation={setSelectedLoadingInformation}
                        setSelectedUnloadingInformation={setSelectedUnloadingInformation}
                    />

                    <LocationInformation
                        locationInformationRef={locationInformationRef}
                        selectedLoadingInformation={selectedLoadingInformation}
                        setSelectedLoadingInformation={setSelectedLoadingInformation}
                        selectedUnloadingInformation={selectedUnloadingInformation}
                        setSelectedUnloadingInformation={setSelectedUnloadingInformation}
                        getDistricts={getDistricts}
                    />

                    <DateInformation
                        dateInformationRef={dateInformationRef}
                        deliverDate={deliverDate}
                        estDeliverDate={estDeliverDate}
                        loadingDate={loadingDate}
                        orderDate={orderDate}
                        setDeliverDate={setDeliverDate}
                        setEstDeliverDate={setEstDeliverDate}
                        setLoadingDate={setLoadingDate}
                        setOrderDate={setOrderDate}
                    />

                    <OrderDetails
                        detailsRef={detailsRef}
                        orderDetails={orderDetails}
                        setOrderDetails={setOrderDetails}
                    />

                    <ExpectedIncomeOutcome
                        expectedIncomeRef={expectedIncomeRef}
                        expectedIncomes={expectedIncomes}
                        isIncome={true}
                        setExpectedIncomes={setExpectedIncomes}
                    />

                    <ExpectedIncomeOutcome
                        expectedIncomeRef={expectedOutcomeRef}
                        expectedIncomes={expectedOutcomes}
                        isIncome={false}
                        setExpectedIncomes={setExpectedOutcomes}
                    />

                    <FileArchives
                        fileArchives={fileArchives}
                        fileArchivesRef={fileArchivesRef}
                        setFileArchives={setFileArchives}
                    />

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveLandOrder}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment >
    )
}

export default LandOrderAdd;